export default "__VITE_ASSET__CIPDBIZh__"